<template>
     <div>
       
 
<!--{{UAParams}}-->
        <b-tabs v-model="activeTab">
            <b-tab-item label="Urinalysis(ข้อมูลทั่วไป)"  :icon="activeTab == 0 ? `checkbox-marked` : `` ">
                    <div class="columns">
			<div class="column  ">
                            <table class="table  is-bordered" width="100%">
                                <tbody>
                                    <tr>
                                            <td width="30%">Collection Technic 
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.colection_tech_id"
                                                    size="is-small"
                                                    @click="UAParams.colection_tech_id=''"
                                                    icon-right="delete" />
                                            </td>
                                            <!-- if some user want to remark to display width 35%  -->
                                            <td :width="widthCol2ForUAType0"> 
                                                 <b-select placeholder=""  expanded v-model="UAParams.colection_tech_id">
                                                        <option  v-for=" colection_tech_mst in UAParams.colection_tech_mst" 
                                                        
                                                        :value="colection_tech_mst.id"
                                                        :key="colection_tech_mst.id">{{colection_tech_mst.val}}</option>
                                                </b-select>
                                            </td>

                                            <!-- if some user want to remark to display width 35%  -->
                                            <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0"  >

                                            </td>    
                                    </tr>    

                                    <tr>
                                                <td width="30%">Color
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.color_id"
                                                    size="is-small"
                                                    @click="UAParams.color_id=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0"> 
                                                    <b-select placeholder=""  expanded v-model="UAParams.color_id">
                                                            <option  v-for=" color_mst in UAParams.color_mst" 
                                                            
                                                            :value="color_mst.id"
                                                            :key="color_mst.id">{{color_mst.val}}</option>
                                                    </b-select>
                                                </td>

                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" >

                                                </td>    
 
                                    </tr>

                              
                                    <tr>
                                                <td width="30%">Transparency
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.trans_id"
                                                    size="is-small"
                                                    @click="UAParams.trans_id=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td  :width="widthCol2ForUAType0"> 
                                                    <b-select placeholder=""  expanded v-model="UAParams.trans_id">
                                                            <option  v-for=" trans_mst in UAParams.trans_mst" 
                                                            
                                                            :value="trans_mst.id"
                                                            :key="trans_mst.id">{{trans_mst.val}}</option>
                                                    </b-select>
                                                </td>
                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" >

                                                </td>    
 
                                    </tr>


                                    <tr>
                                                <td width="30%">RBC
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.rbc"
                                                    size="is-small"
                                                    @click="UAParams.rbc=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td  :width="widthCol2ForUAType0"> 
                                                    <b-select placeholder=""  expanded v-model="UAParams.rbc">
                                                            <option  v-for=" rbc_mst in UAParams.rbc_mst" 
                                                            
                                                            :value="rbc_mst.id"
                                                            :key="rbc_mst.id">{{rbc_mst.val}}</option>
                                                    </b-select>
                                                </td>
                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" >

                                                </td>    
 
                                    </tr>


                                    <tr>
                                                <td width="30%">WBC
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.wbc"
                                                    size="is-small"
                                                    @click="UAParams.wbc=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0" > 
                                                    <b-select placeholder=""  expanded v-model="UAParams.wbc">
                                                            <option  v-for=" wbc_mst in UAParams.wbc_mst" 
                                                            :value="wbc_mst.id"
                                                            :key="wbc_mst.id">{{wbc_mst.val}}</option>
                                                    </b-select>
                                                </td>
                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" >

                                                </td> 
 
                                    </tr>


                                    <tr>
                                                <td width="30%">PH
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.ur_ph"
                                                    size="is-small"
                                                    @click="UAParams.ur_ph=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0"> 
                                                  <b-input type="number"
                                                            v-model="UAParams.ur_ph"
                                                    ></b-input>
                                                </td>  
                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" >

                                                </td>    
                                    </tr>


                                    





                                    <tr>
                                                <td width="30%">SP. Gr.
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.ur_sp_gr"
                                                    size="is-small"
                                                    @click="UAParams.ur_sp_gr=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0"> 
                                                  <b-input type="number"
                                                            v-model="UAParams.ur_sp_gr"
                                                   ></b-input>
                                                </td>     

                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0"  >

                                                </td> 
                                    </tr>




                                     <tr>
                                                <td width="30%">Urine Creatinine
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.ur_creatinine"
                                                    size="is-small"
                                                    @click="UAParams.ur_creatinine=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0"> 
                                                  <b-input type="number"
                                                            v-model="UAParams.ur_creatinine"
                                                    ></b-input>
                                                </td>     
                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" >
                                                   <b-input 
                                                            v-model="UAParams.ur_creatinine_remark"
                                                     ></b-input>
                                                </td> 
                                    </tr>


                                    <tr>
                                                <td width="30%">Urine cortisol
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.ur_cortisol"
                                                    size="is-small"
                                                    @click="UAParams.ur_cortisol=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0"> 
                                                  <b-input type="number"
                                                            v-model="UAParams.ur_cortisol"
                                                    ></b-input>
                                                </td>     
                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" >
                                                    <b-input 
                                                            v-model="UAParams.ur_cortisol_remark"
                                                     ></b-input>
                                                </td> 
                                    </tr>



                                    <tr>
                                                <td width="30%">Urine Protein
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.ur_protein"
                                                    size="is-small"
                                                    @click="UAParams.ur_protein=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0"> 
                                                  <b-input type="number"
                                                            v-model="UAParams.ur_protein"
                                                    ></b-input>
                                                </td>     
                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" >
                                                    <b-input 
                                                            v-model="UAParams.ur_protein_remark"
                                                     ></b-input>
                                                </td> 
                                    </tr>



                                   <tr>
                                                <td width="30%">UCCR
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.uccr"
                                                    size="is-small"
                                                    @click="UAParams.uccr=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0"> 
                                                  <b-input type="number"
                                                            v-model="UAParams.uccr"
                                                   ></b-input>
                                                </td>   

                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0"  > 
                                                  <!-- <b-input 
                                                            v-model="UAParams.uccr_remark"
                                                   ></b-input> -->
                                                </td>     
                                    </tr>



                                    <tr>
                                                <td width="30%">UPCR
                                                 <b-button type="is-danger is-light"
                                                    v-if="UAParams.upcr"
                                                    size="is-small"
                                                    @click="UAParams.upcr=''"
                                                    icon-right="delete" />
                                                </td>
                                                <td :width="widthCol2ForUAType0"> 
                                                  <b-input type="number"
                                                            v-model="UAParams.upcr"
                                                   ></b-input>
                                                </td>   
 
                                                <td :width="widthCol3ForUAType0"  :style="styleCol3ForUAType0" > 
                                                  <!-- <b-input  
                                                            v-model="UAParams.upcr_remark"
                                                   ></b-input> -->
                                                </td>     
                                    </tr>

                                
                                </tbody>
                            </table>
			</div>
						<div class="column">
							<table class="table  is-bordered" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="30%">Nitrite
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.nirite"
                                                    size="is-small"
                                                    @click="UAParams.nirite=''
                                                            UAParams.nirite_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.nirite "
                                                @input=" UAParams.nirite_pos = (UAParams.nirite_pos =='' || UAParams.nirite_pos == null) ? 1 : UAParams.nirite_pos"                                               >
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.nirite==2" expanded v-model="UAParams.nirite_pos ">
                                                        <option  v-for=" nirite_pos_mst in UAParams.nirite_pos_mst" 
                                                        :value="nirite_pos_mst.id"
                                                        :key="nirite_pos_mst.id">{{nirite_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>




                                    <tr>
                                        <td width="30%">Urobilinogen
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.urobilinogen"
                                                    size="is-small"
                                                    @click="UAParams.urobilinogen=''
                                                            UAParams.urobilinogen_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.urobilinogen "
                                                @input=" UAParams.urobilinogen_pos = (UAParams.urobilinogen_pos =='' || UAParams.urobilinogen_pos == null) ? 1 : UAParams.urobilinogen_pos"                                               >
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.urobilinogen==2" expanded v-model="UAParams.urobilinogen_pos ">
                                                        <option  v-for=" urobilinogen_pos_mst in UAParams.urobilinogen_pos_mst" 
                                                        :value="urobilinogen_pos_mst.id"
                                                        :key="urobilinogen_pos_mst.id">{{urobilinogen_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>


                                    <tr>
                                        <td width="30%">Protein
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.protein"
                                                    size="is-small"
                                                    @click="UAParams.protein=''
                                                            UAParams.protein_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.protein "
                                                @input=" UAParams.protein_pos = (UAParams.protein_pos =='' || UAParams.protein_pos == null) ? 1 : UAParams.protein_pos"                                               >
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.protein==2" expanded v-model="UAParams.protein_pos ">
                                                        <option  v-for=" protein_pos_mst in UAParams.protein_pos_mst" 
                                                        :value="protein_pos_mst.id"
                                                        :key="protein_pos_mst.id">{{protein_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>



                                    <tr>
                                        <td width="30%">Blood
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.blood"
                                                    size="is-small"
                                                    @click="UAParams.blood=''
                                                            UAParams.blood_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.blood "
                                                @input=" UAParams.blood_pos = (UAParams.blood_pos =='' || UAParams.blood_pos == null) ? 1 : UAParams.blood_pos"                                               >
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.blood==2" expanded v-model="UAParams.blood_pos ">
                                                        <option  v-for=" blood_pos_mst in UAParams.blood_pos_mst" 
                                                        :value="blood_pos_mst.id"
                                                        :key="blood_pos_mst.id">{{blood_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>




                                    <tr>
                                        <td width="30%">Ketone
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.ketone"
                                                    size="is-small"
                                                    @click="UAParams.ketone=''
                                                            UAParams.ketone_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.ketone "
                                                @input=" UAParams.ketone_pos = (UAParams.ketone_pos =='' || UAParams.ketone_pos == null) ? 1 : UAParams.ketone_pos"                                               >
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.ketone==2" expanded v-model="UAParams.ketone_pos ">
                                                        <option  v-for=" ketone_pos_mst in UAParams.ketone_pos_mst" 
                                                        :value="ketone_pos_mst.id"
                                                        :key="ketone_pos_mst.id">{{ketone_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>




                                    <tr>
                                        <td width="30%">Bilirubin
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.bilirubin"
                                                    size="is-small"
                                                    @click="UAParams.bilirubin=''
                                                            UAParams.bilirubin_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.bilirubin "
                                                @input=" UAParams.bilirubin_pos = (UAParams.bilirubin_pos =='' || UAParams.bilirubin_pos == null) ? 1 : UAParams.bilirubin_pos">
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.bilirubin==2" expanded v-model="UAParams.bilirubin_pos ">
                                                        <option  v-for="bilirubin_pos_mst in UAParams.bilirubin_pos_mst" 
                                                        :value="bilirubin_pos_mst.id"
                                                        :key="bilirubin_pos_mst.id">{{bilirubin_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>



                                    <tr>
                                        <td width="30%">Glucose
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.glucose"
                                                    size="is-small"
                                                    @click="UAParams.glucose=''
                                                            UAParams.glucose_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.glucose "
                                                @input=" UAParams.glucose_pos = (UAParams.glucose_pos =='' || UAParams.glucose_pos == null) ? 1 : UAParams.glucose_pos">
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.glucose==2" expanded v-model="UAParams.glucose_pos ">
                                                        <option  v-for="glucose_pos_mst in UAParams.glucose_pos_mst" 
                                                        :value="glucose_pos_mst.id"
                                                        :key="glucose_pos_mst.id">{{glucose_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>



                                    <tr>
                                        <td width="30%">Fat Droplet
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.fat_drp"
                                                    size="is-small"
                                                    @click="UAParams.fat_drp=''
                                                            UAParams.fat_drp_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.fat_drp "
                                                @input=" UAParams.fat_drp_pos = (UAParams.fat_drp_pos =='' || UAParams.fat_drp_pos == null) ? 1 : UAParams.fat_drp_pos">
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.fat_drp==2" expanded v-model="UAParams.fat_drp_pos ">
                                                        <option  v-for="fat_drp_pos_mst in UAParams.fat_drp_pos_mst" 
                                                        :value="fat_drp_pos_mst.id"
                                                        :key="fat_drp_pos_mst.id">{{fat_drp_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>




                                    <tr>
                                        <td width="30%">Bacteria 
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.bact"
                                                    size="is-small"
                                                    @click="UAParams.bact=''
                                                            UAParams.bact_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.bact "
                                                @input=" UAParams.bact_pos = (UAParams.bact_pos =='' || UAParams.bact_pos == null) ? 1 : UAParams.bact_pos">
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.bact==2" expanded v-model="UAParams.bact_pos ">
                                                        <option  v-for="bact_pos_mst in UAParams.bact_pos_mst" 
                                                        :value="bact_pos_mst.id"
                                                        :key="bact_pos_mst.id">{{bact_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>



                                     



                                    <tr>
                                        <td width="30%">Leukocyte  
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.leu"
                                                    size="is-small"
                                                    @click="UAParams.leu=''
                                                            UAParams.leu_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.leu "
                                                @input=" UAParams.leu_pos = (UAParams.leu_pos =='' || UAParams.leu_pos == null) ? 1 : UAParams.leu_pos">
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.leu==2" expanded v-model="UAParams.leu_pos ">
                                                        <option  v-for="leu_pos_mst in UAParams.leu_pos_mst" 
                                                        :value="leu_pos_mst.id"
                                                        :key="leu_pos_mst.id">{{leu_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>



                                    <tr>
                                        <td width="30%">Sperm
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.sprem"
                                                    size="is-small"
                                                    @click="UAParams.sprem=''
                                                            UAParams.sprem_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.sprem "
                                                @input=" UAParams.sprem_pos = (UAParams.sprem_pos =='' || UAParams.sprem_pos == null) ? 1 : UAParams.sprem_pos">
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.sprem==2" expanded v-model="UAParams.sprem_pos ">
                                                        <option  v-for="sprem_pos_mst in UAParams.sprem_pos_mst" 
                                                        :value="sprem_pos_mst.id"
                                                        :key="sprem_pos_mst.id">{{sprem_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>


 
                                    <tr>
                                        <td width="30%">Fungi 
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.fungi"
                                                    size="is-small"
                                                    @click="UAParams.fungi=''
                                                            UAParams.fungi_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.fungi "
                                                @input=" UAParams.fungi_pos = (UAParams.fungi_pos =='' || UAParams.fungi_pos == null) ? 1 : UAParams.fungi_pos">
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.fungi==2" expanded v-model="UAParams.fungi_pos ">
                                                        <option  v-for="fungi_pos_mst in UAParams.fungi_pos_mst" 
                                                        :value="fungi_pos_mst.id"
                                                        :key="fungi_pos_mst.id">{{fungi_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>



                                    <tr>
                                        <td width="30%">Yeast 
                                             <b-button type="is-danger is-light"
                                                    v-if="UAParams.yeast"
                                                    size="is-small"
                                                    @click="UAParams.yeast=''
                                                            UAParams.yeast_pos=''"
                                                    icon-right="delete" />
                                        </td>
                                        <td width="30%">
                                                <b-select placeholder=""  expanded v-model="UAParams.yeast "
                                                @input=" UAParams.yeast_pos = (UAParams.yeast_pos =='' || UAParams.yeast_pos == null) ? 1 : UAParams.yeast_pos">
                                                        <option  v-for=" np_mst in UAParams.np_mst" 
                                                        :value="np_mst.id"
                                                        :key="np_mst.id">{{np_mst.name}}</option>
                                                </b-select>
                                        </td>
                                        <td width="40%">
                                                <b-select placeholder="" v-if="UAParams.yeast==2" expanded v-model="UAParams.yeast_pos ">
                                                        <option  v-for="yeast_pos_mst in UAParams.yeast_pos_mst" 
                                                        :value="yeast_pos_mst.id"
                                                        :key="yeast_pos_mst.id">{{yeast_pos_mst.val}}</option>
                                                </b-select>
                                        </td>
                                    </tr>




                                </tbody>
                            </table>
						</div>
					</div>
            </b-tab-item>
            <b-tab-item label="Urinalysis(เฉพาะ Cast,Cystal และ Epith)" :icon="activeTab == 1 ? `checkbox-marked` : `` ">
                 <b-tabs v-model="activeTab1">
                   <b-tab-item label="Cast"  :icon="activeTab1 == 0 ? `checkbox-marked` : `` ">
                                    <div class="columns">
                                        <div class="column">
                                                <b-field label=""  >
                                                    <b-select placeholder=""  expanded v-model="UAParams.cast_np ">
                                                            <option  v-for=" np_mst in UAParams.np_mst" 
                                                            :value="np_mst.id"
                                                            :key="np_mst.id">{{np_mst.name}}</option>
                                                    </b-select> 
                                                    <p class="control">
                                                        <b-button type="is-danger is-light"
                                                                v-if="UAParams.cast_np"
                                                                 
                                                                @click="UAParams.cast_np='' "
                                                                icon-right="delete" />  
                                                    </p>
                                                </b-field>
                                        </div>
                                        <div class="column is-two-thirds">
                                             <table class="table  is-bordered" width="70%" v-if="UAParams.cast_np == 2">
                                                    <tbody>
                                                        <tr v-for="cast_pos_mst in UAParams.cast_pos_mst" :key="cast_pos_mst.id">
                                                            <td>{{cast_pos_mst.name}}

                                                                <b-button type="is-danger is-light"
                                                                v-if="cast_pos_mst.val"
                                                                size="is-small" 
                                                                @click="cast_pos_mst.val='' "
                                                                icon-right="delete" />  
                                                            </td>
                                                            <td>
                                                                <b-select placeholder=""  expanded v-model="cast_pos_mst.val ">
                                                                        <option  v-for=" lab_ua_pos_mst1 in UAParams.lab_ua_pos_mst2" 
                                                                        :value="lab_ua_pos_mst1.id"
                                                                        :key="lab_ua_pos_mst1.id">{{lab_ua_pos_mst1.val}}</option>
                                                                </b-select> 
                                                                 
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                             </table>           
                                        </div>
                                    </div>
                   </b-tab-item> 
                   <b-tab-item label="Cystal"  :icon="activeTab1 == 1 ? `checkbox-marked` : `` ">
                                     <div class="columns">
                                        <div class="column">
                                                <b-field label=""  >
                                                    <b-select placeholder=""  expanded v-model="UAParams.cystal_np">
                                                            <option  v-for=" np_mst in UAParams.np_mst" 
                                                            :value="np_mst.id"
                                                            :key="np_mst.id">{{np_mst.name}}</option>
                                                    </b-select> 
                                                    <p class="control">
                                                        <b-button type="is-danger is-light"
                                                                v-if="UAParams.cystal_np"
                                                                 
                                                                @click="UAParams.cystal_np='' "
                                                                icon-right="delete" />  
                                                    </p>
                                                </b-field>
                                        </div>
                                        <div class="column is-two-thirds">
                                             <table class="table  is-bordered"  width="70%" v-if="UAParams.cystal_np == 2">
                                                    <tbody>
                                                        <tr v-for="cystal_pos_mst in UAParams.cystal_pos_mst" :key="cystal_pos_mst.id">
                                                            <td>{{cystal_pos_mst.name}}

                                                                <b-button type="is-danger is-light"
                                                                v-if="cystal_pos_mst.val"
                                                                size="is-small" 
                                                                @click="cystal_pos_mst.val='' "
                                                                icon-right="delete" />  
                                                            </td>
                                                            <td>
                                                                <b-select placeholder=""  expanded v-model="cystal_pos_mst.val ">
                                                                        <option  v-for=" lab_ua_pos_mst1 in UAParams.lab_ua_pos_mst1" 
                                                                        :value="lab_ua_pos_mst1.id"
                                                                        :key="lab_ua_pos_mst1.id">{{lab_ua_pos_mst1.val}}</option>
                                                                </b-select> 
                                                                 
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                             </table>           
                                        </div>
                                    </div>
                   </b-tab-item> 
                   <b-tab-item label="Epith"  :icon="activeTab1 == 2 ? `checkbox-marked` : `` ">
                                        <div class="columns">
                                        <div class="column">
                                                <b-field label=""  >
                                                    <b-select placeholder=""  expanded v-model="UAParams.epith_np">
                                                            <option  v-for=" np_mst in UAParams.np_mst" 
                                                            :value="np_mst.id"
                                                            :key="np_mst.id">{{np_mst.name}}</option>
                                                    </b-select> 
                                                    <p class="control">
                                                        <b-button type="is-danger is-light"
                                                                v-if="UAParams.epith_np"
                                                                 
                                                                @click="UAParams.epith_np='' "
                                                                icon-right="delete" />  
                                                    </p>
                                                </b-field>
                                        </div>
                                        <div class="column is-two-thirds">
                                             <table class="table  is-bordered" width="70%" v-if="UAParams.epith_np == 2">
                                                    <tbody>
                                                        <tr v-for="epith_pos_mst in UAParams.epith_pos_mst" :key="epith_pos_mst.id">
                                                            <td>{{epith_pos_mst.name}}

                                                                <b-button type="is-danger is-light"
                                                                v-if="epith_pos_mst.val"
                                                                size="is-small" 
                                                                @click="epith_pos_mst.val='' "
                                                                icon-right="delete" />  
                                                            </td>
                                                            <td>
                                                                <b-select placeholder=""  expanded v-model="epith_pos_mst.val ">
                                                                        <option  v-for=" lab_ua_pos_mst2 in UAParams.lab_ua_pos_mst2" 
                                                                        :value="lab_ua_pos_mst2.id"
                                                                        :key="lab_ua_pos_mst2.id">{{lab_ua_pos_mst2.val}}</option>
                                                                </b-select> 
                                                                 
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                             </table>           
                                        </div>
                                    </div>
                   </b-tab-item> 
                 </b-tabs>  
            </b-tab-item>
        </b-tabs>    
    </div>
</template>


<script>

import { mapMutations, mapState} from "vuex";


export default {
    name : "UAParam",
     props:{
        mode : Number,  // 0 ----> input mode  , 1 -----> edit mode
    },
    computed:{
            ...mapState({
                dataModelMNLABAutomate: state => state.manually_create_lab_automate.dataModelMNLABAutomate ,
                UAParams: state => state.manually_create_lab_automate.UAParams ,
            }),

      


    },
    methods:{
         ...mapMutations({
                // setUAExtend: 'manually_create_lab_automate/setUAExtend',  
         }),
         inputNegPos(){
          if(this.UAParams.nirite_pos =='' || this.UAParams.nirite_pos == null){
            this.UAParams.nirite_pos = 1
          }
         }
    },
    data(){
        return {
         
            activeTab : 0,
            activeTab1 : 0,

            widthCol2ForUAType0 : '35%',
            widthCol3ForUAType0 : '35%' ,
            styleCol3ForUAType0 : '',// 'visibility:hidden ; border: none;',
        }
    }
}
</script>


<style>
 
   .full-width-select {
        width: 100%;
        box-sizing: border-box;
    }

    
</style>